import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/lib/supabase';
import type { FileRecord } from '@/types';

export function useFiles(itemId: string) {
  const [files, setFiles] = useState<FileRecord[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const { data } = await supabase
      .from('files')
      .select('*')
      .eq('item_id', itemId)
      .order('created_at', { ascending: false });
    setFiles((data ?? []) as FileRecord[]);
    setLoading(false);
  }, [itemId]);

  useEffect(() => { load(); }, [load]);

  return { files, loading, reload: load };
}
